/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useState} from 'react';
import Avatar from '@ion/dls/src/components/avatar/Avatar';
import UserProfileMobile from '../components/profile/UserProfileMobile';
import MobileHeaderLogo from './MobileHeaderLogo';
import styles from './MobileHeader.module.scss';

export interface HeaderProps {
  username: string;
  onHelp: Function;
  onLogout: () => void;
  isLoggingOut?: boolean;
  handleClickOpen: () => void;
  dialogOpen: boolean;
  setDialogOpen: Function;
  isSelected?: boolean;
}

/**
 * @MobileHeader
 */
export const MobileHeader = ({username}: HeaderProps) => {
  const [isUserProfile, setIsUserProfile] = useState(false);

  const handleClose = useCallback(function() {
    setIsUserProfile(false);
  }, []);

  const onAvatarClick = useCallback(function() {
    setIsUserProfile(true);
  }, []);

  return (
    <div className={styles.flexContainer}>
      <div className={styles.leftContent}>
        <MobileHeaderLogo />
      </div>
      <div className={styles.rightContent}>
        <span className={styles.rightSubContent}>
          <Avatar className={styles.avatar}
            name={username}
            onClick={onAvatarClick} />
        </span>
      </div>
      <UserProfileMobile showProfile={isUserProfile} handleClose={handleClose} />
    </div>
  );
};
export default MobileHeader;
